import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { acceptCookieConsent, hasCookieConsent } from "@/lib/privacyConsent";

export const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    acceptCookieConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-0 w-full flex justify-center z-50 pointer-events-none">
      <div className="pointer-events-auto border border-primary/20 bg-gradient-to-r from-white via-[hsl(var(--background))] to-[hsl(var(--secondary)/0.14)] shadow-xl rounded-xl px-6 py-4 flex flex-col md:flex-row items-center gap-4 max-w-2xl w-full mx-4 animate-fade-in">
        <div className="flex items-center gap-3">
          {/* SVG Cookie Icon */}
          <span className="text-2xl md:text-3xl">
            <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="16" fill="#F6C177" />
              <circle cx="14" cy="18" r="2" fill="#B08968" />
              <circle cx="24" cy="24" r="1.5" fill="#B08968" />
              <circle cx="20" cy="12" r="1.2" fill="#B08968" />
              <circle cx="27" cy="16" r="1" fill="#B08968" />
              <circle cx="17" cy="26" r="1" fill="#B08968" />
            </svg>
          </span>
          <div className="text-foreground text-sm md:text-base">
            <span className="font-semibold text-foreground">We use cookies!</span> &nbsp;
            This site uses cookies for analytics and personalized content. By continuing to browse, you agree to our use of cookies.{' '}
            <a href="/privacy-policy" className="font-medium text-foreground underline decoration-primary/60 underline-offset-2 hover:text-[hsl(197_54%_18%)] hover:decoration-secondary" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </div>
        </div>
        <Button onClick={handleAccept} className="ml-0 md:ml-4 px-6 py-2">
          Got it!
        </Button>
      </div>
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.7s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </div>
  );
};

export default CookieConsentBanner;
